import tinymce from "tinymce";
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.css';

 /* Import plugins */
 import 'tinymce/plugins/advlist';
 import 'tinymce/plugins/code';
 import 'tinymce/plugins/autoresize';
 import 'tinymce/plugins/emoticons';
 import 'tinymce/plugins/emoticons/js/emojis';
 import 'tinymce/plugins/link';
 import 'tinymce/plugins/lists';
 import 'tinymce/plugins/autolink';
 import 'tinymce/plugins/quickbars';
 import 'tinymce/plugins/media';
 import 'tinymce/plugins/image';
 import 'tinymce/plugins/visualblocks';
 import 'tinymce/plugins/visualchars';

 import 'tinymce/plugins/table';

 import 'tinymce/models/dom';
 /* Import premium plugins */
 /* NOTE: Download separately and add these to /src/plugins */
 /* import './plugins/checklist/plugin'; */
 /* import './plugins/powerpaste/plugin'; */
 /* import './plugins/powerpaste/js/wordimport'; */

 /* Import content css */
//  import contentUiCss from 'tinymce/skins/ui/oxide/content.css';
//  import contentCss from 'tinymce/skins/content/default/content.css';

tinymce.init({
    selector: '.editor.tinymce',
    menubar: false,
    toolbar: 'undo redo | fontselect fontsizeselect formatselect | ' +
    'bold italic link | h1 h2 h3 |alignleft aligncenter ' +
    'alignright alignjustify | bullist numlist outdent indent | ' +
    'removeformat',
    plugins: "textpattern link advlist autoresize autolink quickbars image media table hr lists",
    quickbars_selection_toolbar: "h1 h2 h3 | alignleft aligncenter alignright alignfull | numlist bullist outdent indent" ,
    content_style: "@import url('https://fonts.googleapis.com/css2?family=Jost&display=swap'); body { font-family: 'Jost', serif; font-size: 15px; color: #111827; } img {max-width: 100%;}",
    language: 'tr_TR',
    language_url: '/js/tinymce/tr_TR.js',
    images_upload_url: '/admin/file',
    images_upload_credentials: true
  });